import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Layout from '@/components/BaseLayout/Layout.vue';
import Title from '@/components/Title/Title.vue';
import About from '@/components/About/About.vue';
import Benefits from '@/components/Benefits/Benefits.vue';
import PlansComparison from '@/components/Plans/PlansComparison.vue';
import Solutions from '@/components/Solutions/Solutions.vue';
import Depoimentos from '@/components/Depoimentos/Depoimentos.vue';
import Faq from '@/components/Faq/Faq.vue';
import { useFaqStore } from '@/store/faqStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const faqStore = useFaqStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, null, {
    default: _withCtx(() => [
      _createVNode(Title, {
        height: 28,
        imgUrl: "url('@/assets/img/bg-serv-white-title.svg')"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: "https://advservice-images.s3.amazonaws.com/solutions/Logo%2B1.png",
            class: "h-24 w-auto lg:h-44",
            alt: "Trabalhista Service logo"
          }, null, -1)
        ]))]),
        _: 1
      }),
      _createVNode(About, {
        title: "O maior aliado de advogados trabalhistas de sucesso.",
        text: "Gaste menos tempo com tarefas repetitivas e atividades pequenas, e tenha disponibilidade para atender e conquistar mais clientes.",
        service: "trabalhista",
        "video-url": "https://advservice-images.s3.amazonaws.com/videos/trabalhista+service+final+.mp4",
        "thumbnail-url": "https://advservice-images.s3.amazonaws.com/solutions/Trabalhista%20Service.png"
      }),
      _createVNode(Benefits, { solutionId: 1 }),
      _createVNode(PlansComparison, { "solution-id": 1 }),
      _createVNode(Solutions, { title: "Mais soluções" }),
      _createVNode(Depoimentos, { title: "Depoimentos" }),
      _createVNode(Faq, {
        title: "Perguntas Frequentes",
        questions: _unref(faqStore).questions
      }, null, 8, ["questions"])
    ]),
    _: 1
  }))
}
}

})